// Vite entry point. Mounts the SPA root. The pre-React bootstrap
// (window.APP_CONFIG, TWEAK_DEFAULTS, the demo-prefill scrubber) still
// runs from the inline <script> in index.html BEFORE this module loads,
// so APP_CONFIG is populated by the time App reads it.
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app.jsx";

// ── Back-compat shim ─────────────────────────────────────────────────
// A handful of component bodies still reference these via `window.X`
// (the pre-Vite global pattern). They're all proper ES module exports
// now; re-exposing them on `window` keeps those call sites working
// without rewriting hundreds of `window.Api.*` references. Assigned
// before render so the values exist by the time any component reads
// them. TODO: convert the remaining window.X references to imports and
// delete this shim.
import { Api } from "./api.jsx";
import { Pager } from "./components.jsx";
import { OAuthProviderButtons, OAuthCallback } from "./oauth.jsx";
import { PASSWORD_HINT, passwordPolicyError } from "./auth.jsx";
window.Api = Api;
window.Pager = Pager;
window.OAuthProviderButtons = OAuthProviderButtons;
window.OAuthCallback = OAuthCallback;
window.PASSWORD_HINT = PASSWORD_HINT;
window.passwordPolicyError = passwordPolicyError;

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
